import { z } from 'zod';
export const createTeamSchema = z.object({
    name: z.string().trim().min(1).max(100),
    parentTeamId: z.string().uuid().optional(),
    managerMembershipId: z.string().uuid().optional(),
});
export const updateTeamSchema = createTeamSchema.partial();
export const setTeamMembersSchema = z.object({
    membershipIds: z.array(z.string().uuid()),
});
export const teamMemberSchema = z.object({
    membershipId: z.string().uuid(),
    displayName: z.string(),
    email: z.string().email(),
});
export const teamResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    parentTeamId: z.string().uuid().nullable(),
    managerMembershipId: z.string().uuid().nullable(),
    memberCount: z.number().int(),
    members: z.array(teamMemberSchema),
});
//# sourceMappingURL=teams.js.map